/*
 * @Description:
 * @Author: zhanghang
 * @Date: 2022-07-29 15:46:35
 * @LastEditors: shenah
 * @LastEditTime: 2025-04-25 16:07:09
 */
import dataAnalysisEvent from "./dataAnalysisEvent/index";
import dataAndGraphRelationMixin from "./dataAndGraphRelationMixin.js";
import { dataEvent } from "_dataview/output/utils/commonEvent.js";
export default {
  mixins: [dataAnalysisEvent, dataAndGraphRelationMixin],
  computed: {
    includeEvents() {
      let commonEvents = Object.keys(dataEvent);
      return [...commonEvents, ...this.otherEvents];
    },
    eventCursorPointerStyle() {
      let style = {};
      if (this.isEventCursorPointer) {
        style["cursor"] = "pointer";
        style["--data-view-click-cursor"] = "pointer";
      }
      return style;
    },
  },
  data() {
    return {
      isShowComponent: true,
      pureHeader: [], // 最纯洁的头部
      pureData: [], // 最纯洁的数据
      componentType: "dataAnalysis",
      otherEvents: [
        "刷新",
        "还原数据",
        "追加数据",
        "删除数据",
        "显示",
        "隐藏",
        "获取当前值",
      ],
    };
  },
  methods: {
    //点击单元格依赖组件关联方法
    loadClickCellEvents(data) {
      let { fn } = this.eventRelativeDeal.clickCell;
      //给组件设置当前数据
      this.currentComponentData = data;
      this.handleCommonEmit(fn, data);
    },
    //双击依赖组件关联方法
    loaddbClickEvents(data) {
      let { fn } = this.eventRelativeDeal.dbclick;
      //给组件设置当前数据
      this.currentComponentData = data;
      this.handleCommonEmit(fn, data);
    },
    //点击搜索按钮
    loadSearchEvents(data) {
      let { fn } = this.eventRelativeDeal.search;
      //给组件设置当前数据
      this.currentComponentData = data;
      this.handleCommonEmit(fn, data);
    },
    // change的依赖事件
    loadChangeEvents(data) {
      try {
        let { fn } = this.eventRelativeDeal.change;
        //给组件设置当前数据
        this.currentComponentData = data;
        this.handleCommonEmit(fn, data);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
